import tableAppCategories from './tableAppCategories';

export default {
  title: 'Category Management',
  attributeName: 'appCategory',
  getURL: 'appId/areaId/appCategory',
  createURL: 'appId/areaId/appCategory',
  updateURL: 'appId/areaId/appCategory',
  removeURL: 'appId/areaId/appCategory',
  sessionParams: ['appId', 'areaId'],
  removeNameField:'name',
  removeText:'You are about to remove the category with name ##name##.',
  tableConfig: tableAppCategories,
  autoUpdate: true,
};
